import React from 'react';
import { tradizioneContent, siteInfo } from '../data/mock';

const TradizioneSection = () => {
  return (
    <div 
      className="min-h-screen pt-20 pb-12 bg-cover bg-center bg-fixed relative"
      style={{
        backgroundImage: `url('${siteInfo.dashboardImage}')`
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-white/90" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8">
        {/* Title */}
        <div className="mb-8">
          <h2 className="font-cinzel text-2xl md:text-3xl font-semibold text-amber-800 tracking-wide text-center">
            {tradizioneContent.title}
          </h2>
          <div className="w-full max-w-[420px] md:max-w-[520px] h-0.5 bg-amber-700 mt-4 mx-auto" />
        </div>

        {/* First Text */}
        <div className="mb-8">
          {tradizioneContent.paragraphs.map((para, idx) => (
            <p key={idx} className="text-stone-700 leading-relaxed text-base md:text-lg text-center">
              {para}
            </p>
          ))}
        </div>

        {/* Black & White Image - After first text */}
        <div className="mb-12">
          <div className="rounded-xl overflow-hidden shadow-xl border-2 border-amber-200 max-w-2xl mx-auto">
            <img 
              src={tradizioneContent.imageBlackWhite} 
              alt="Tradizione - Artigiani al lavoro"
              className="w-full h-64 md:h-80 object-cover"
            />
          </div>
        </div>

        {/* Second Title */}
        <div className="mb-8">
          <h3 className="font-cinzel text-2xl md:text-3xl font-semibold text-amber-800 text-center">
            {tradizioneContent.secondTitle}
          </h3>
          <div className="w-full max-w-[260px] md:max-w-[300px] h-0.5 bg-amber-700 mt-4 mx-auto" />
        </div>

        {/* Second Paragraphs */}
        <div className="space-y-6 mb-12">
          {tradizioneContent.secondParagraphs.map((para, idx) => (
            <p key={idx} className="text-stone-700 leading-relaxed text-base md:text-lg text-center">
              {para}
            </p>
          ))}
        </div>

        {/* Color Image - At the bottom */}
        <div className="mt-8">
          <div className="rounded-xl overflow-hidden shadow-xl border-2 border-amber-200 max-w-2xl mx-auto">
            <img 
              src={tradizioneContent.imageColor} 
              alt="Padre e figlio al lavoro"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradizioneSection;
